import React from "react";
import "./InputError.scss";

interface InputErrorProps {
  children: React.ReactNode;
}
const InputError = ({ children }: InputErrorProps) => {
  return (
    <div className="input-error">
      <p className="input-error__message">{children}</p>
    </div>
  );
};

export default InputError;
